import React, { createContext, useContext, useState, useCallback } from 'react';
import { IdealCustomerProfile } from '../types';

interface SuggestionWizardContextType {
  isOpen: boolean;
  selectedIcp: IdealCustomerProfile | null;
  openWizard: () => void;
  openWithIcp: (icp: IdealCustomerProfile) => void;
  closeWizard: () => void;
}

const SuggestionWizardContext = createContext<SuggestionWizardContextType | null>(null);

export const SuggestionWizardProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const [isOpen, setIsOpen] = useState(false);
  const [selectedIcp, setSelectedIcp] = useState<IdealCustomerProfile | null>(null);

  const openWizard = useCallback(() => {
    setSelectedIcp(null);
    setIsOpen(true);
  }, []);

  const openWithIcp = useCallback((icp: IdealCustomerProfile) => {
    setSelectedIcp(icp);
    setIsOpen(true);
  }, []);

  const closeWizard = useCallback(() => {
    setIsOpen(false);
  }, []);

  return (
    <SuggestionWizardContext.Provider
      value={{
        isOpen,
        selectedIcp,
        openWizard,
        openWithIcp,
        closeWizard,
      }}
    >
      {children}
    </SuggestionWizardContext.Provider>
  );
};

export const useSuggestionWizard = (): SuggestionWizardContextType => {
  const context = useContext(SuggestionWizardContext);
  if (!context) {
    throw new Error('useSuggestionWizard must be used within a SuggestionWizardProvider');
  }
  return context;
};
